import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { HealthState, SystemHealthResponse } from './_systemHealthTypes';
import axios from "axios";
import { buildApiUrl } from '../../axios/urlCreator';
import { handleAxiosError } from '../../axios/handleAxiosError';

const initialState: HealthState = {
    statuses: [],
    status: 'idle',
    checkedAtUtc: null,
    error: null,
};

const systemHealthSlice = createSlice({
    name: 'systemHealth',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchHealthStatuses.pending, (state) => {
                state.status = 'loading';
                state.error = null;
            })
            .addCase(fetchHealthStatuses.fulfilled, (state, action) => {
                state.status = 'idle';
                state.statuses = action.payload.statuses;
                state.checkedAtUtc = action.payload.checkedAtUtc;
                state.error = null;
            })
            .addCase(fetchHealthStatuses.rejected, (state, action) => {
                state.status = 'failed';
                state.error = action.payload ?? action.error.message ?? null;
            });
    },
});

export const fetchHealthStatuses = createAsyncThunk<SystemHealthResponse, void, { rejectValue: string }>(
    'health/fetchHealthStatuses',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get<SystemHealthResponse>(buildApiUrl('systemStatus'), { timeout: 10_000 });
            return response.data;
        } catch (error) {
            return rejectWithValue(axios.isAxiosError(error) ? handleAxiosError(error) : 'Service health could not be refreshed.');
        }
    }
);


export const { } = systemHealthSlice.actions;
export default systemHealthSlice.reducer;
